import React, {useState} from 'react';
import { Header, Hero, BannerImage, AwardSection,Perks, ExploreSection, Footer } from './components';
import './App.css';
// import BannerOne from './assets/hero.jpg';
import BannerOne from './assets/hero.jpg';
import BannerTwo from './assets/wa-franke.jpg';

function App() {
  const [award, setAward] = useState('hidden');
  const [honorsInfo, setHonorsInfo] = useState('hidden');
  const [perks, setPerks] = useState('hidden');
  const [explore, setExplore] = useState('hidden');
  
  const showAward = () => {
    setAward('open');
  };
  
  const showHonorsInfo = () => {
    setHonorsInfo('open');
  };
  
  const showPerks = () => {
    setPerks('open');
  };
  
  const showVisit = () => {
    setExplore('open');
  }

  return (
    <div className="main-container">
      <Header></Header>
      <BannerImage setSection={showAward} bannerImage={BannerOne} altText="Fountain in front of Old Main at the University of Arizona campus." />
      <Hero/>
      <AwardSection setSection={showHonorsInfo} show={award} />
      <Perks show={perks} />
      <BannerImage setSection={showPerks} extraClass={'customHeight'} bannerImage={BannerTwo} altText="Two students sitting in the WA Franke lounge working on their laptops" />
      <ExploreSection show={explore} />
      <Footer />
    </div>
  );
}

export default App;
